import React from "react"
import {Grid} from "@mui/material";
import { PageSectionTitle } from "components/commons";
import {t} from "@lingui/macro";
import {EconomicCard} from "./economic-card/economic-card";
import {EconomicCardsData} from "./economic-card/models";
import { FinancialPanChart } from "./finantial-pan/financial-pan-chart";

interface FinancialPanProps {
    chartData: {
        year: number[]
    }[]
    selectValuesFinancialPan: string[]
}

interface FinalcialPanState {

}

export class FinancialPan extends React.Component<FinancialPanProps, FinalcialPanState>
{
    render(){
        return (
            <>
                <PageSectionTitle title={t({ id: "economic-management.financial-pan", message: "Panoramica finanziaria" })}/>
                <Grid container spacing={3} sx={{mt: 1}}>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard  cardType={EconomicCardsData.TOTAL_REVENUE} value={0.00}/>
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard  cardType={EconomicCardsData.COMMISSIONS_CASHIN} value={0.00}/>
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard  cardType={EconomicCardsData.COMMISSIONS_PAID} value={0.00}/>
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard  cardType={EconomicCardsData.TOTAL_EXPENSES} value={0.00}/>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <FinancialPanChart chartData={this.props.chartData} selectValues={this.props.selectValuesFinancialPan}/>
                    </Grid>
                </Grid>
            </>

        )
    }
}
